module.exports = __webpack_public_path__ + "img/NO-RECORDED.f806307c.jpg";